import { createFileRoute, redirect } from '@tanstack/react-router';
import { OrganisationStructureManagement } from '../components/OrganisationStructureManagement';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/org-structure')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: OrgStructureSettingsComponent,
});

function OrgStructureSettingsComponent() {
  return <OrganisationStructureManagement />;
}
